import React, { useEffect, useState } from "react";
import "./VerticalScrollbar.css";

const sections = ["home", "about", "services", "technologies"];

const VerticalScrollbar = () => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carousel = document.getElementById("home");
      const carouselHeight = carousel?.offsetHeight || 0;

      setVisible(scrollY > carouselHeight - 100);

      const mid = scrollY + window.innerHeight / 2;
      let current = 0;
      sections.forEach((id, i) => {
        const el = document.getElementById(id);
        if (el && mid >= el.offsetTop) {
          current = i;
        }
      });
      setActiveIndex(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!isLargeScreen) return null;
  return (
    <div className={`vertical-scrollbar ${visible ? "visible" : "hidden"}`}>
      {sections.map((section, index) => (
        <div
          key={section}
          className={`dot ${index === activeIndex ? "active" : ""}`}
          onClick={() => scrollToSection(section)}
        />
      ))}
    </div>
  );
};

export default VerticalScrollbar;
